// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".book-turn__header__navigation li .previous-period-wrapper .paper-date-wrapper .el-date-editor .el-input__inner{width:100%;padding:0;cursor:pointer}", ""]);
// Exports
module.exports = exports;
